import React from 'react'
import { useTranslation } from 'react-i18next'

import List from '../../../../components/list/List'
import MapPanelWrapper from '../../../../components/map/MapPanelWrapper'
import { useMapActions, useMapState } from '../../../../components/map/MapContext'
import Link from '../../../../components/actions/Link'
import ListItemWrapper from '../../../../components/list/ListItemWrapper'
import FlexGrid, { FlexCol } from '../../../../components/structure/FlexGrid'
import Checkbox from '../../../../components/shapes/Checkbox'
import Text from '../../../../packages/kiti/components/presentation/Text'

const ClusterPanel = () => {
  const { t } = useTranslation('map')
  const { setShowUsers, setShowPlaces } = useMapActions()
  const { showUser, showPlaces } = useMapState()
  return (
    <MapPanelWrapper title={t('clustering')} right="-0.1rem">
      <List>
        <Link block onClick={() => setShowUsers(!showUser)}>
          <ListItemWrapper>
            <FlexGrid paddingGutter={0.4} justify="flex-start">
              <FlexCol>
                <Checkbox active={showUser} />
              </FlexCol>
              <FlexCol flex={1}>
                <Text weight="500" size="small">
                  {t('showUsers')}
                </Text>
              </FlexCol>
            </FlexGrid>
          </ListItemWrapper>
        </Link>

        <Link block onClick={() => setShowPlaces(!showPlaces)}>
          <ListItemWrapper>
            <FlexGrid paddingGutter={0.4} justify="flex-start">
              <FlexCol>
                <Checkbox active={showPlaces} />
              </FlexCol>
              <FlexCol flex={1}>
                <Text weight="500" size="small">
                  {t('showPlaces')}
                </Text>
              </FlexCol>
            </FlexGrid>
          </ListItemWrapper>
        </Link>
      </List>
    </MapPanelWrapper>
  )
}

export default ClusterPanel
